<div
  [(className)]="topicSearchObj.className"
  [ngStyle]="{ 'background-color': topicSearchObj.background, color: topicSearchObj.color }"
>
  <h2 aria-label="Title" class="text-start">{{ topicSearchObj?.title }}</h2>
  <ul
    [ngClass]="{
      'topic-search': true,
      'per-row': topicSearchObj.eachRow,
      hover: topicSearchObj.hoverTheme
    }"
  >
    @for (topic of topicSearchObj.rowChips; track topic; let i = $index) {
      <li
        class="badge badge-pill badge-default"
        tabindex="0"
        [title]="'Search for: ' + topic.description"
        [ngStyle]="{
          'background-color': topicSearchObj.topicBack,
          color: topicSearchObj.topicColor
        }"
        (click)="chooseTopic(topic.query)"
        (keyup.enter)="chooseTopic(topic.query)"
      >
        <a><i class="fa fa-search" aria-hidden="true"></i> {{ topic.description }} </a>
      </li>
    }
  </ul>
</div>
